module.exports = __webpack_public_path__ + "static/img/yg2.754bfe8.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/yg2.png
// module id = mQNU
// module chunks = 7